import React from 'react'
import PropTypes from 'prop-types'
import styles from './style.module.scss'
import MyImage from '@shared/components/myImage'
import { Col, Row } from 'react-bootstrap'
import CustomLink from '@shared/components/customLink'

function Teams({ data }) {
  return (
    <>
      <h3 className="small-head d-flex align-items-center  mb-0">
        <span>Teams</span>
      </h3>
      <Row className={`d-flex gap-4 mb-2 flex-nowrap scroll-list ${styles.teamsListing}`}>
        {data?.data?.map((d, i) => {
          return (
            <CustomLink key={i} href={d?.sArticleUrl ? d?.sArticleUrl : ''}>
              <Col className="cursor-pointer">
                <MyImage src={d?.oImg?.sUrl} height={120} width={120} alt={i} />
                {/* <h5 className="mt-2">{d?.sTitle}</h5> */}
              </Col>
            </CustomLink>
          )
        })}
      </Row>
    </>
  )
}

Teams.propTypes = {
  data: PropTypes.object
}

export default Teams
